import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="w-full bg-bone py-20" aria-labelledby="bonuses-title" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-17" data-mp="plslc7o6v6at">
        <div className="max-w-2xl" data-id="element-18" data-mp="aua82hmprpv5">
          <h2 id="bonuses-title" className="font-display text-3xl font-black leading-tight tracking-tight text-court-950 sm:text-4xl" data-id="element-19" data-mp="asz1ka1vw40c">
            🎁 You Also Get 6 Strategic Bonuses
          </h2>
          <p className="mt-3 text-lg text-court-700" data-id="element-20" data-mp="5wi5mtog0lcp">Included at no extra cost</p>
          <p className="mt-6 inline-block rounded-full bg-court-950 px-5 py-2.5 text-sm font-semibold text-ball" data-id="element-21" data-mp="3o1lfsst9nnjz">
            Real combined value: $318 — today included FREE
          </p>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-22" data-mp="1ma8jut9a0q02">
          {bonuses.map(bonus => <li key={bonus.id} className="flex h-full flex-col rounded-2xl border border-court-950/10 bg-white p-7" data-id="element-23" data-mp="1r9v07bkeimd3">
              <div className="flex items-baseline justify-between gap-3" data-id="element-24" data-mp="3icbunweqtxof">
                <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-court-600" data-id="element-25" data-mp="3dek4p7xnslmv">
                  {bonus.id}
                </span>
                <span className="text-xs font-semibold text-court-950" data-id="element-26" data-mp="3n552wu9f7o59">
                  <span className="text-court-600 line-through" data-id="element-27" data-mp="3n79d1txwxjdz">{bonus.value}</span> → FREE
                </span>
              </div>
              <h3 className="mt-4 font-display text-xl font-extrabold leading-snug tracking-tight text-court-950" data-id="element-28" data-mp="2ugr103f7o7of">
                {bonus.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-court-700" data-id="element-29" data-mp="38e5tjh0rgvkm">{bonus.description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}